import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe, Language, LANGUAGE_BY_DEFAULT } from '../../../common';
import { APP_LANGUAGES } from '../../../services';
import { AppFacade } from '../../../store';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'container-default-header',
    templateUrl: './default-header.component.html',
    styleUrls: ['./default-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
@AutoUnsubscribe
export class DefaultHeaderComponent implements OnInit {
  @Input() languageFromQueryParams?: Language;
  @Input() showIntrackLogo = true;
  @Input() showLanguage = true;
  @Output() languageFromSelect = new EventEmitter<Language>();
  language = Language;
  languageControl: FormControl<Language>;
  languageList: Language[] = APP_LANGUAGES;
  subscriptions: Subscription[] = [];

  constructor(private appFacade: AppFacade) {}

  ngOnInit(): void {
    this.languageControl = new FormControl<Language>(this.languageFromQueryParams || LANGUAGE_BY_DEFAULT);
    this.subscriptions.push(
      this.languageControl.valueChanges.subscribe((language: Language) => {
        this.appFacade.changeLang(language);
        this.languageFromSelect.emit(language);
      }),
      this.appFacade.currentLanguage$
        .pipe(filter(Boolean))
        .subscribe((language: Language) => this.languageControl.setValue(language, { emitEvent: false })),
    );
  }
}
